import React from 'react';

export const text = (
	<span>
		<h2 className="text-center">{`Die Geschichte von Ignaz Semmelweis – dem „Retter der Mütter"`}</h2>
		<p> 	
			{`
Der österreichisch-ungarische Arzt Ignaz Semmelweis (1818–1865) ist dafür bekannt,
den Zusammenhang zwischen mangelnder Handhygiene bei Ärzten und dem
Auftreten von Kindbettfieber nachgewiesen zu haben. Durch einfaches
Händewaschen konnte er die Sterblichkeit unter Wöchnerinnen drastisch senken. 
Deshalb wurde er als „Retter der Mütter“ bekannt.`}
		 </p>

		<p> 	
			{`Die Wochenbettzeit umfasst die ersten 10 bis 14 Tage nach der Geburt. In dieser Zeit
kann es vorkommen, dass frischgebackene Mütter Fieber bekommen. Wenn das
Fieber über mehrere Tage anhält, spricht man von Kindbettfieber. Heute weiß man,
dass es sich dabei um eine bakterielle Infektion der Gebärmutter handelt, die
während oder nach der Geburt entsteht und mit Antibiotika behandelt werden kann.
Früher glaubte man aber für eine lange Zeit, dass die Krankheit auf überirdische und
unvermeidbare Einflüsse zurückzuführen sei.`}
		 </p>
		<p> 	
			{`Im frühen 19. Jahrhundert entstanden in vielen europäischen Städten neue
Krankenhäuser. Obwohl bei den meisten Frauen Hausgeburten üblich blieben, stieg
die Anzahl der Klinikgeburten, vor allem in Fällen komplizierter Schwangerschaften
oder unverheirateter Frauen. Gleichzeitig stieg dort die Zahl der Kindbettfieberfälle,
mit Sterblichkeitsraten von bis zu 30 Prozent.`}{' '}
		 </p>
		<p> 	
			{`Ignaz Semmelweis legte 1844 an der Universität Wien sein medizinisches
Staatsexamen ab und spezialisierte sich auf Geburtshilfe. 1846 begann er als Arzt an
der Geburtsklinik in Wien zu arbeiten. In der ersten Abteilung dieser Klinik arbeiteten
die Ärzte und die Medizinstudenten. In der zweiten Abteilung arbeiteten die
Hebammen und die Hebammenschülerinnen.`}
		 </p>
		<p> 	
			{`Zu Semmelweis‘ Entsetzen war die Sterberate von Kindbettfieber in der ersten
Abteilung mit 18 Prozent viel höher als die 2-prozentige Sterberate in der zweiten
Abteilung.`}
		 </p>
		<p> 	
			{`Die unterschiedliche Verteilung der Sterbefälle ließ ihn an der Theorie der
überirdischen Einflüsse zweifeln und veranlasste ihn dazu, mögliche Einflussfaktoren
systematisch zu untersuchen.`}
		 </p>

		<p> 	
			{`Während die Patientendichte sowie das Geschlecht und Verhalten der Hebammen
und Medizinstudenten als Erklärung ausgeschlossen werden konnten, konzentrierte
sich Semmelweis auf die Untersuchung psychologischer Einflüsse. Ein Stressfaktor
für gesunde Frauen in der ersten, aber nicht in der zweiten Abteilung war die Angst,
die durch den Anblick der Priester, die die sterbenden Frauen besuchten, verursacht
wurde. Nach der Beseitigung dieses Einflusses sank die Sterblichkeit auf der ersten
Station jedoch nicht.`}
		 </p>

		<p> 	
			{`Auch die Geburtsstellung konnte als Einfluss ausgeschlossen werden, nachdem
Semmelweis die Verwendung einer einheitlichen Seitenlage auf beiden Stationen
anordnete und die Sterblichkeit auf der ersten Station sich dadurch nicht verringerte.
Der Durchbruch gelang, nachdem sich Semmelweis’ Kollege Jakob Kolletschka bei
der Obduktion einer an Kindbettfieber verstorbenen Frau in den Finger geschnitten
hatte, Symptome des Kindbettfiebers entwickelte und schließlich starb. Durch diesen
Vorfall erkannte Semmelweis, dass „Leichengerüche“ an den Händen im
Zusammenhang standen mit dem Kindbettfieber, da die Ärzte und
Medizinstudenten, aber nicht die Hebammen, jeden Morgen vor der Untersuchung
der Gebärenden Obduktionen durchführten. Daraufhin befahl Semmelweis den
Ärzten und Studenten das Waschen der Hände und Instrumente mit Chlorkalk nach
der Durchführung von Obduktionen, woraufhin die Sterblichkeit in der Klinik
drastisch sank.`}
		 </p>

		<p> 	
			{`Trotz des Erfolgs seiner Maßnahme traten weitere Fälle von Kindbettfieber auf.
Semmelweis bemerkte, dass Frauen auch dann erkrankten, wenn Ärzte zuvor keine
Obduktionen durchgeführt hatten. Als er und seine Kollegen nach der Untersuchung
einer erkrankten Frau mehrere gesunde Frauen untersuchten, ohne sich erneut die
Hände zu waschen, starben fast alle dieser Patientinnen. So erkannte er, dass die
Krankheit neben „Leichengift“ auch durch „verwesende Stoffe“ lebender Kranker
übertragen werden konnte.`}
		 </p>

		<p> 	
			{`Seine Erkenntnisse stießen jedoch auf heftigen Widerstand. Die
Krankheitsübertragung von Mensch zu Mensch war zu dieser Zeit wissenschaftlich
noch nicht geklärt und viele Ärzte wollten nicht akzeptieren, dass sie selbst die
Infektionen verursachten. Sie sahen ihre Arbeit als ehrenhaft und lehnten die
Vorstellung ab, mit „schmutzigen Händen“ Leben zu nehmen. Semmelweis wurde als
Querulant gesehen, er wurde verspottet, entlassen und schließlich in eine
psychiatrische Anstalt eingewiesen, wo er starb.`}
		 </p>

	</span>
);
export default text;
